import * as React from "react"
import {Loader} from "components/Map/MapHelpers/MapSearch.Manager";
import {TechnicalBreak, TechnicalBreakProps} from "Modules/TechnicalBreak/Component/TechnicalBreak.Component";

const TechnicalBreakView = ({
  period,
  title,
  content,
}: Pick<TechnicalBreakProps, 'period' | 'title' | 'content'>) => {
  return (
    <TechnicalBreak
      logo={<img src={'/images/icons/selltracking-vehis-logo.svg'}/>}
      loader={<div className="loader-wrapper"><Loader/></div>}
      title={title}
      content={content}
      period={period}
    />
  )
}

export default TechnicalBreakView



// WEBPACK FOOTER //
// ./src/Modules/TechnicalBreak/View/TechnicalBreak.View.tsx